import React from "react";
import {
  TelegramIcon,
  TelegramShareButton,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  OKIcon,
  OKShareButton,
  EmailIcon,
  EmailShareButton,
} from "react-share";
import { IoArrowBack } from "react-icons/io5";
import { FiCopy } from "react-icons/fi";
import styles from "./ShareModalContent.module.scss";
import { useCopyToClipboard } from "../../../../hooks/useCopyToClipboard";

interface ShareModalContentProps {
  url: string;
  text: string;
  onClose: () => void;
}

export const ShareModalContent: React.FC<ShareModalContentProps> = ({
  url,
  text,
  onClose,
}) => {
  const { copy, copied } = useCopyToClipboard();

  const handleCopyLink = async () => {
    await copy(url);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={onClose}>
          <IoArrowBack size={24} />
        </button>
        <h2 className={styles.title}>Поделиться</h2>
        <div className={styles.placeholder} />
      </div>

      <div className={styles.content}>
        <div className={styles.iconsRow}>
          <div onClick={onClose}>
            <TelegramShareButton url={url} title={text}>
              <TelegramIcon size={40} round />
            </TelegramShareButton>
          </div>

          <div onClick={onClose}>
            <WhatsappShareButton url={url} title={text}>
              <WhatsappIcon size={40} round />
            </WhatsappShareButton>
          </div>

          <div onClick={onClose}>
            <VKShareButton url={url} title={text}>
              <VKIcon size={40} round />
            </VKShareButton>
          </div>

          <div onClick={onClose}>
            <OKShareButton url={url} title={text}>
              <OKIcon size={40} round />
            </OKShareButton>
          </div>

          <div onClick={onClose}>
            <EmailShareButton
              url={url}
              subject={text}
              body={`${text}\n\n${url}`}
            >
              <EmailIcon size={40} round />
            </EmailShareButton>
          </div>

          <button
            className={`${styles.copyButton} ${copied ? styles.copied : ""}`}
            onClick={handleCopyLink}
            title="Скопировать ссылку"
          >
            <div className={styles.copyCircle}>
              <FiCopy size={20} />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModalContent;
